import basePath from "../path";

const teamsManagementPath = `${basePath}/teams-management`;

export default teamsManagementPath;
